module.exports = __webpack_public_path__ + "img/normal-buy.8606f028.png";